<template>
  <admin-layout isLayout="ideas">
    <IdeaHeader
      isLayout="ideas"
      title="Dahil Olduğum Projeler"
      :subTitle="subTitle"
    />
    <IdeaForm
      class="my-idea-container"
      @search-filter="ideaSearchFilter"
      @clear-search-filter="clearSearchFilter"
      @continuity-tracking-list="continuityTrackingBulkListModal($event)"
      isIdea="my-idea"
      isForm="product"
      isControlBtn="MyAssignments"
      suggestionTypeId="3"
      :totalRecords="myAssTotalRecords"
    />
    <div
      v-if="getMyAssData && getMyAssData.length > 0"
      style="margin: 0 15px"
      class="ideas-table-wrapper"
    >
      <AdminTable
        :columns="columns"
        :rows="getMyAssData"
        @table-detail="cardDetail"
        @table-edit="editSuggestion"
        @table-delete="deleteCardShowModal"
        isLayout="idea"
      />
      <div class="row mt-4 d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="myAssTotalRecords"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <NotIdea v-else />
    <transition name="fade">
      <IdeaDetail
        v-if="isIdeaModal"
        @close="isIdeaModal = $event"
        :detailData="ideaModalData"
        isSuggestion="idea"
      />
    </transition>
    <transition name="fade">
      <ShareIdeas
        v-if="isShareIdea"
        @close="isShareIdea = $event"
        :editNewestsData="editPagedData"
        isIdea="my-idea"
      />
    </transition>
    <transition name="fade">
      <CardDelete
        v-if="isCardDelete"
        @close="isCardDelete = $event"
        @delete="deleteCard"
        :isSuggestion="false"
      />
    </transition>
    <transition name="fade">
      <AutomotiveProduct
        v-if="isProductIdea"
        @close="isProductIdea = $event"
        :editPagedData="editPagedData"
        isIdea="my-idea"
      />
      <ContinuityTrackingBulkModal
        v-if="isContinuityTrackingBulkEvaluation"
        :totalRecords="totalRecords"
        :continuityTrackingList="getContinuityTrackingList"
        :title="title"
        @save-continuity-tracking-bulk="saveContinuityTrackingBulkList"
        @get-continuity-tracking-paged-list="getContinuityTrackingPagedList"
        @close="isContinuityTrackingBulkEvaluation = $event"
      />
    </transition>
  </admin-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { suggestionService, suggestionRdService, upload } from "../../services";
import { fileTypeCheck } from "../../helpers";

import AdminTable from "../../components/Admin/AdminTable.vue";
import IdeaForm from "../../components/MyIdea/IdeaForm.vue";
import IdeaHeader from "../../components/MyIdea/IdeaHeader.vue";
import AutomotiveProduct from "../../components/Modals/AutomotiveProduct.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
import IdeaDetail from "../../components/Main/Cards/Modals/CardDetail.vue";
import ShareIdeas from "../../components/Modals/ShareIdeas.vue";
import CardDelete from "../../components/Main/Cards/Modals/CardDelete.vue";
import NotIdea from "../../components/MyIdea/NotIdea.vue";
import ContinuityTrackingBulkModal from "../../components/Admin/ContinuityTrackingBulkModal.vue";
export default {
  components: {
    AdminLayout,
    IdeaHeader,
    IdeaForm,
    AdminTable,
    IdeaDetail,
    ShareIdeas,
    CardDelete,
    NotIdea,
    AutomotiveProduct,
    ContinuityTrackingBulkModal,
  },
  name: "MyAssignments",
  data() {
    return {
      title: "PROJE FİKRİ SÜREKLİLİK TAKİBİ",
      ideaModalData: null,
      isIdeaModal: false,
      isContinuityTrackingBulkEvaluation: false,
      columns: [
        {
          label: "Fikir No.",
          field: "SuggestionNumber",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Fikir Tarihi",
          field: "SuggestionDate",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Atama Rolü",
          field: "MyAssignment",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Proje Adı",
          field: "Title",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Değer Akımı",
          field: "ValueCurrentName",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Beğeni Sayısı",
          field: "LikeCount",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Yorum Sayısı",
          field: "CommentCount",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Statü",
          field: "SuggestionStatusName",
          sortable: false,
          thClass: "vgt-center-align",
        },
        {
          label: "",
          field: "actionProductIdea",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
      ],
      onlyContinuityTrackingSuggestion: null,
      perPage: 15,
      currentPage: 1,
      isShareIdea: false,
      isProductIdea: false,
      editPagedData: null,
      isCardDelete: false,
      ideaFilterData: null,
      subTitle:
        "Ekipte yer aldığınız tüm süreç iyileştirme proje fikirlerinizi buradan listeleyebilirsiniz.",
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      myAssTotalRecords: "ideas/myAssTotalRecords",
      totalRecords: "suggestionRD/getContTrackingTotalRecords",
    }),
    getMyAssData() {
      return this.$store.getters["ideas/getMyAssData"];
    },
    getContinuityTrackingList() {
      return this.$store.getters["suggestionRD/getContinuityTrackingList"];
    },
  },
  watch: {
    async currentPage() {
      await this.searchFilter(this.ideaFilterData);
    },
  },
  methods: {
    async clearSearchFilter(event) {
      await this.searchFilter(event);
    },
    async ideaSearchFilter(event) {
      this.currentPage = 1;
      await this.searchFilter(event);
    },
    async searchFilter(event) {
      let tmpData = null;
      this.ideaFilterData = event;
      tmpData = {
        ...event,
        ...{
          pageSize: this.perPage,
          page: parseInt(this.currentPage - 1),
          loginUserId: this.user.Data.UserId,
          isAssignment: true,
        },
      };
      await this.$store.dispatch("ideas/deleteMyAssignmentData");
      await this.$store.dispatch("ideas/setMyAssignmentsData", tmpData);
    },
    async cardDetail(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      this.ideaModalData = item;
      this.ideaModalData.ProjectPresentationDocumentFiles = [];
      this.ideaModalData.DownloadFile = [];

      if (this.ideaModalData.FileIds && this.ideaModalData.FileIds.length > 0) {
        for await (let element of this.ideaModalData.FileIds) {
          const res = await upload.fetchDownloadFile(element);
          this.ideaModalData.DownloadFile.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      if (
        this.ideaModalData.ProjectPresentationDocumentIds &&
        this.ideaModalData.ProjectPresentationDocumentIds.length > 0
      ) {
        for await (let element of this.ideaModalData
          .ProjectPresentationDocumentIds) {
          const res = await upload.fetchDownloadFile(element);
          this.ideaModalData.ProjectPresentationDocumentFiles.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      this.$store.dispatch("loading/setIsLoading", false);
      this.isIdeaModal = true;
    },
    async editSuggestion(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      const tmpData = item;
      tmpData.DownloadFile = [];
      if (item.FileIds.length > 0) {
        item.FileIds.forEach(async (element) => {
          const res = await upload.fetchDownloadFile(element);
          tmpData.DownloadFile.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
            fileType: fileTypeCheck(res.Data.Extension),
          });
        });
      }
      if (this.user.Data.ProjectDocumentId != null) {
        const res = await upload.fetchDownloadFile(
          this.user.Data.ProjectDocumentId
        );
        tmpData.ProjeDocument = {
          DownloadBinary: res.Data.DownloadBinary,
          Extension: res.Data.Extension,
          Filename: res.Data.Filename,
          Id: res.Data.Id,
        };
      }
      this.editPagedData = tmpData;
      this.$store.dispatch("loading/setIsLoading", false);
      if (item.SuggestionTypeId == 3) {
        this.isProductIdea = true;
      } else {
        this.isShareIdea = true;
      }
    },
    async deleteCard() {
      try {
        const res = await suggestionService.fetchDeleteSuggestion(
          this.cardDeleteDataId
        );
        if (res.Message == "Suggestion is deleted") {
          this.$toast.success("İşleminiz başarıyla tamamlandı.", {
            position: "top",
          });
          this.$store.dispatch("suggestionNewests/deleteNewestsData");
          this.$store.dispatch("suggestionNewests/setData");
          await this.searchFilter(this.ideaFilterData);
        } else {
          this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
            position: "top",
          });
        }
      } catch (error) {
        this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
          position: "top",
        });
      }
    },
    deleteCardShowModal(item) {
      this.isCardDelete = true;
      this.cardDeleteDataId = item.Id;
    },
    async continuityTrackingBulkListModal() {
      await this.setContinuityTrackingList();
      this.isContinuityTrackingBulkEvaluation = true;
    },
    async getContinuityTrackingPagedList(event) {
      this.$store.dispatch("suggestionRD/deleteContinuityTrackingBulkData");
      this.$store.dispatch("suggestionRD/setContinuityTrackingBulkData", event);
    },
    async setContinuityTrackingList() {
      let body = {
        pageSize: 10,
        pageIndex: parseInt(this.currentPage - 1),
        loginUserId: this.user.Data.UserId,
        isAdminPage: true,
        onlyContinuityTrackingSuggestion: true,
      };
      await this.$store.dispatch("suggestionRD/setContinuityTrackingBulkData", body);
    },
    async saveContinuityTrackingBulkList(event) {
      let res = await suggestionRdService.fetchSaveBulkContinuityTrackingSuggestionRds(event);
      if (res.Success) {
        this.$toast.success("Başarılı bir şekilde güncellendi.", {
          position: "top",
        });
        this.isContinuityTrackingBulkEvaluation = false;
        await this.searchFilter();
      } else {
        this.$toast.error("Lütfen zorunlu alanları doldurunuz!.", {
          position: "top",
        });
      }
    },
  },
  async created() {
    await this.setContinuityTrackingList();
    if (this.getMyAssData.length == 0) this.searchFilter();
  },
};
</script>